import { Component, OnInit, ElementRef, Renderer2, AfterContentInit  } from '@angular/core';
import { UtilsResource } from 'src/app/resources/UtilsResource.resource';


declare var window: any;
declare var $: any;

@Component({
  selector: 'app-visa-client',
  templateUrl: './visa-client.component.html',
  styleUrls: ['./visa-client.component.scss']
})
export class VisaClientComponent implements OnInit, AfterContentInit {
  route;
  public display: boolean;
  public show: boolean;
  public itsMobile = false;

  SlideOptions = {
    items: 1,
    dots: true,
    nav: false,
    margin: 0,
    stagePadding: 0,
    autoHeight: true,
    loop: true,
    autoplay: false,
  };

  classesCss = {
    NAV_HIDDEN: ' nav-hidden',
    ADVANCE:' advance',
    VIDEO_HIDDEN: ' video-hidden',
    ACTIVE: 'active',
    VIDEO_VOYAGE: ' video-voyage'
  };

  sectionPrev = '';
  menu1Class = this.classesCss.NAV_HIDDEN;
  menu1BarClass = '';
  contrast:boolean = false;
  videoClass = this.classesCss.VIDEO_HIDDEN;
  videoSrc = '';
  menu2Class = this.classesCss.NAV_HIDDEN;
  menu2BarClass = '';

  sectionSettings:any = {
    'item-33': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }

    },
    'item-34': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-35': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-36': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-37': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-38': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-39': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '1',
        menuItem: 'menu1Item1'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/463606914/rendition/720p/file.mp4?loc=external&signature=e8ba8c587fee8c8537c4a0298905c203dbaecc9b787bb3109314dcd415f67ecd'
      }
    },
    'item-40': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '2',
        menuItem: 'menu1Item2'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/489997832/rendition/720p/file.mp4?loc=external&signature=92232fa9e96f2da46ca0473306d81adc11bffb13179ad5d3119cef4037630624'
      }
    },
    'item-41': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '3',
        menuItem: 'menu1Item3'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/462698340/rendition/720p/file.mp4?loc=external&signature=d580b92b2238907eb38d3a89b4263f378655199cce3cd4ea1e826905a18edef9'
      }
    },
    'item-42': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '4',
        menuItem: 'menu1Item4'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/463577355/rendition/720p/file.mp4?loc=external&signature=fc1c38ee6ead99a70816eb34bbeed3c82a81be87d4781ef8291c7219cf8d6e5d'
      }
    },
    'item-43': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '5',
        menuItem: 'menu1Item5'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/463577355/rendition/720p/file.mp4?loc=external&signature=fc1c38ee6ead99a70816eb34bbeed3c82a81be87d4781ef8291c7219cf8d6e5d'
      }
    },
    'item-44': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '6',
        menuItem: 'menu1Item6'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/463194609/rendition/720p/file.mp4?loc=external&signature=d82905b4e4b524759dad9f995a5d8a14c3e3b213796636e622d9ccfa9887520d'
      }
    },
    'item-45': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '7',
        menuItem: 'menu1Item7'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/490045989/rendition/720p/file.mp4?loc=external&signature=6aef359f20dd7851f1a94740b1ad446111839397df9eadf5031c129e6797d13e'
      }
    },
    'item-46': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '8',
        menuItem: 'menu1Item8'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/463577347/rendition/720p/file.mp4?loc=external&signature=ef8a76505fe8aff36b353bc3365b8e3667428536d4bfd31598a515ed0ae5a9a7'
      }
    },
    'item-47': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '8',
        menuItem: 'menu1Item8'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/463577347/rendition/720p/file.mp4?loc=external&signature=ef8a76505fe8aff36b353bc3365b8e3667428536d4bfd31598a515ed0ae5a9a7'
      }
    },
    'item-48': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '9',
        menuItem: 'menu1Item9'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/466737035/rendition/540p/file.mp4?loc=external&signature=282aab4a0fd96d81f5cdfe7e4002a8f5e8e476e40a83d236d72df5157775742a'
      }
    },
    'item-49': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-50': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-51': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-52': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-53': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-54': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-55': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-56': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-57': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-58': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '0',
        menuItem: 'menu1Item0'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    }

  };

  constructor(
    private el: ElementRef,
    private render: Renderer2
  ) {
    this.route = window.location.hash;
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      if (this.itsMobile) {
        try {
          const sectionSettingsKeys = Object.keys(this.sectionSettings)
          Object.values(this.sectionSettings).forEach((item:any, index) => {
            if(item.video && item.video.show) {
              this.loadSrcVideo(`${sectionSettingsKeys[index]}-video`, item.video.src);
            }})
        } catch(error) {
          UtilsResource.ShowLog('*** SolutionsDosComponent - ngOnInit - error', error);
        }
      }
    });
  }

  ngOnInit(): void {
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }
    for (let position = 33; position <= 58; position++) {
      const target = document.getElementById('item-' + position);
      if (target != null) {
        this.createObserver(target);
      }
    }
    document.querySelectorAll(".btn-v").forEach(element => {
      element.id.split("btn-")[1]
      element.addEventListener("click", () => {
        document.querySelector("#item-" + element.id.split("btn-")[1]).scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      })
    })
  }

  createObserver(target: Element) {
    const options = {
      root: null,
      threshold: 0.9
    };

    const that = this;
    const observer = new IntersectionObserver((entries: any[], observer: any) => {
      entries.forEach((entry) => {
        if(entry.isIntersecting) {
          UtilsResource.ShowLog(entry.target.id, 'visible state', entry.isIntersecting, 'height', entry.target.clientHeight);
          that.loadSectionSettings(entry);
          that.sectionPrev = entry.target.id;
        }
      });
    }, options);
    observer.observe(target);
  }

  loadSectionSettings(entry) {
    const up = Number(this.sectionPrev.replace('item-', '')) > Number(entry.target.id.replace('item-',''))
    if (this.sectionSettings[entry.target.id]) {
      const sectionSettings = this.sectionSettings[entry.target.id];
      if (sectionSettings.idMenu == 'menu1') {
        this.menu2Class = this.classesCss.NAV_HIDDEN;
        if (sectionSettings.menu.show) {
          this.menu1Class = this.menu1Class.replace(sectionSettings.menu.class, '');
          const menuItem = document.getElementById(sectionSettings.menu.menuItem);
          if (up) {
            this.loadPrev();
          }
          if (menuItem) {
            this.render.addClass(menuItem, this.classesCss.ACTIVE);
          }
          if (this.menu1BarClass.lastIndexOf(sectionSettings.menu.barClass) == -1) {
            this.menu1BarClass += sectionSettings.menu.barClass;
          }
        } else {
          if (this.menu1Class.lastIndexOf(sectionSettings.menu.class) == -1) {
            this.menu1Class += sectionSettings.menu.class;
          }
        }
        if (sectionSettings.contrast) {
          this.contrast = sectionSettings.contrast;
        } else {
          this.contrast = false;
        }

        if (sectionSettings.video.show) {
          this.videoClass = this.videoClass.replace(sectionSettings.video.class, '');
          this.videoSrc = sectionSettings.video.src;
          if (this.itsMobile) {
            try {
              this.pauseAllVideos();
              const video:any = document.getElementById(`${entry.target.id}-video`);
              if(video) {
                video.play();
              }
            } catch (error) {
              UtilsResource.ShowLog('*** SolutionsDosComponent - loadSectionSettings - error', error);
            }
          }
        } else {
          if (this.videoClass.lastIndexOf(sectionSettings.video.class) == -1) {
            this.videoClass += sectionSettings.video.class;
          }
        }
      } else if (sectionSettings.idMenu == 'menu2') {
        this.menu1Class = this.classesCss.NAV_HIDDEN;
        if (sectionSettings.menu.show) {
          this.menu2Class = this.menu1Class.replace(sectionSettings.menu.class, '');
          const menuItem = document.getElementById(sectionSettings.menu.menuItem);
          if (up) {
            this.loadPrev();
          }
          if (menuItem) {
            this.render.addClass(menuItem, this.classesCss.ACTIVE);
          }
          if (this.menu2BarClass.lastIndexOf(sectionSettings.menu.barClass) == -1) {
            this.menu2BarClass += sectionSettings.menu.barClass;
          }
        } else {
          if (this.menu2Class.lastIndexOf(sectionSettings.menu.class) == -1) {
            this.menu2Class += sectionSettings.menu.class;
          }
        }
        if (sectionSettings.contrast) {
          this.contrast = sectionSettings.contrast;
        } else {
          this.contrast = false;
        }
        if (sectionSettings.video.show) {
          this.videoClass = this.videoClass.replace(sectionSettings.video.class, '');
          this.videoSrc = sectionSettings.video.src;
          if (this.itsMobile) {
            try {
              this.pauseAllVideos();
              const video:any = document.getElementById(`${entry.target.id}-video`);
              if (video) {
                video.play();
              }
            } catch (error) {
              UtilsResource.ShowLog('*** SolutionsDosComponent - loadSectionSettings - error', error);
            }
          }
        } else {
          if (this.videoClass.lastIndexOf(sectionSettings.video.class) == -1) {
            this.videoClass += sectionSettings.video.class;
          }
        }
      }

      if (this.contrast) {
        if (this.videoClass.lastIndexOf(this.classesCss.VIDEO_VOYAGE) == -1) {
          this.videoClass += this.classesCss.VIDEO_VOYAGE;
        }
      } else {
        this.videoClass = this.videoClass.replace(this.classesCss.VIDEO_VOYAGE, '');
      }
    }
  }

  loadPrev() {
    const sectionSettings = this.sectionSettings[this.sectionPrev];
    const menuItem = document.getElementById(sectionSettings.menu.menuItem);
    if (sectionSettings.idMenu == 'menu1') {
      this.menu1BarClass = this.menu1BarClass.replace(sectionSettings.menu.barClass, '');
      if (menuItem) {
        this.render.removeClass(menuItem, this.classesCss.ACTIVE);
      }
    } else if (sectionSettings.idMenu == 'menu2') {
      this.menu2BarClass = this.menu2BarClass.replace(sectionSettings.menu.barClass, '');
      if (menuItem) {
        this.render.removeClass(menuItem, this.classesCss.ACTIVE);
      }
    }
  }

  Navigate(elem: HTMLElement) {
    elem.scrollIntoView({ behavior: 'smooth' });
  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  menuClick(idMenu, menuItem) {
    const index = Object.values(this.sectionSettings).findIndex((item:any) => item.idMenu == idMenu && item.menu.menuItem == menuItem);
    console.log('*** VisaClient - menuClick - idMenu - menuItem - index', idMenu, menuItem, index);
    if (index && index > -1) {
      const sectionKeys = Object.keys(this.sectionSettings);
      const element = sectionKeys[index];
      if (element) {
        document.getElementById(element).scrollIntoView();
        this.menu1BarClass = '';
        this.menu2BarClass = '';
        $(`.${this.classesCss.ACTIVE}`,$(`#${idMenu}`)).removeClass(this.classesCss.ACTIVE);
        for (let position = 0; position <= index; position++) {
          const entry = {
            target: {
              id: sectionKeys[position]
            }
          }
          this.loadSectionSettings(entry)
        }
      }
    }
  }

  pauseAllVideos() {
    try {
      const videos = $('video');
      $.each(videos, (index, value) => {
        value.pause();
      });
    } catch (error) {
      UtilsResource.ShowLog('*** SolutionsDosComponent - pauseAllVideos - error', error);
    }
  }

  loadSrcVideo(idVideo:string, src:string) {
    try {
      const video:any = document.getElementById(idVideo);
      if(video) {
        video.setAttribute('src', src);
        video.load();
      }
    } catch (error) {
      console.log('*** VisaClient - loadSrcVideo - error', error);
    }
  }
}
